import { forwardRef } from "react";
import { ReactComponent as LeaderboardIcon } from "../../../assets/icons/visualizza-classifica.svg";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const IconLeaderboard = forwardRef<SVGSVGElement, SvgIconProps>(
  function IconLeaderboard(props, ref) {
    return (
      <SvgIcon
        ref={ref}
        component={LeaderboardIcon}
        inheritViewBox
        {...props}
        sx={{ padding: "2px", ...props.sx }}
      />
    );
  },
);

export default IconLeaderboard;
